import React from 'react';
import { FormattedMessage } from 'react-intl';
import MENU_EMBED_STEPS from './MenuEmbedPlan';
import STARTER_STEPS, { type PlanStep } from './StarterPlan';
import SYSCO_STEPS from './SyscoPlan';

type PlanSteps = {
  steps: PlanStep[];
  congratulations: {
    header: React.ReactNode;
    body: React.ReactNode;
  };
};

const planSteps: Record<string, PlanSteps> = {
  menu_embed: {
    congratulations: {
      body: <FormattedMessage defaultMessage="A member of our team will reach out within 24–48 hours using your preferred contact method. You can get into your dashboard and explore Popmenu straight away." />,
      header: <FormattedMessage defaultMessage="Congrats, you're good to go." />,
    },
    steps: MENU_EMBED_STEPS,
  },
  starter: {
    congratulations: {
      body: <FormattedMessage defaultMessage="A member of our team will reach out within 24–48 hours using your preferred contact method. You can get into your dashboard, continue building your website, and explore Popmenu straight away." />,
      header: <FormattedMessage defaultMessage="Congrats, you're good to go." />,
    },
    steps: STARTER_STEPS,
  },
  sysco: {
    congratulations: {
      body: <FormattedMessage defaultMessage="A member of our team will reach out within 24–48 hours using your preferred contact method. You can get into your dashboard and explore Popmenu straight away." />,
      header: <FormattedMessage defaultMessage="Congrats, you're good to go." />,
    },
    steps: SYSCO_STEPS,
  },
};

export const getPlanSteps = (productPlan: string): PlanSteps => (planSteps[productPlan] ?? planSteps.starter) as unknown as PlanSteps;
